<template>
  <div class="editDetail" v-if="result && shopShow">
    <van-nav-bar :title="lang.infoEdit" :left-arrow="!$route.query.fromapp" @click-left="prev" />
    <div class="info">
      <!-- 物业编号 -->
      <p v-if="proInfo.propertyNo">
        <span>{{ lang.number }}</span
        ><span class="value  van-ellipsis">{{ proInfo.propertyNo }}</span>
      </p>
      <!-- 楼盘编号 -->
      <p>
        <span>{{ lang.PropertyID }}</span
        ><span class="values">{{ proInfo.propertyID }}</span>
      </p>
      <!-- 地区 -->
      <p>
        <span>{{ lang.area }}</span
        ><span class="value van-ellipsis">{{ proInfo.gscopeNameWithCulture }} {{ proInfo.estateNameWithCulture }}</span>
      </p>
      <!-- 价格 -->
      <div>
        <p v-if="proInfo.rentalType == 1">
          <span class="saleSpan">{{ lang.sale }}</span>
          <span class="value">
            <span v-if="!(proInfo.subCategory[6] || proInfo.subCategory[7])" class="valuePaid">{{ post.getPrice(proInfo.paidSalePrice, urls.indexOf('en-us') > -1 ? 'en-us' : urls.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk') }}</span>
            <span v-if="proInfo.subCategory && (proInfo.subCategory[6] || proInfo.subCategory[7]) && proInfo.paidSalePrice" :class="['valuePaid','topPaid',{valuePaids:urls.indexOf('en-us') > -1 && proInfo.unPaidSalePrice }]">{{proInfo.subCategory && (proInfo.subCategory[6] || proInfo.subCategory[7])?lang.alPaid+'&nbsp;':''}}{{ post.getPrice(proInfo.paidSalePrice, urls.indexOf('en-us') > -1 ? 'en-us' : urls.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk') }}</span>
            <span v-if="proInfo.subCategory && proInfo.unPaidSalePrice && (proInfo.subCategory[6] || proInfo.subCategory[7])" :class="['valuePaid',{valuePaids:urls.indexOf('en-us') > -1 && proInfo.paidSalePrice }]">{{ proInfo.subCategory && (proInfo.subCategory[6] || proInfo.subCategory[7])?lang.unPaid+'&nbsp;':'' }}{{ post.getPrice(proInfo.unPaidSalePrice, urls.indexOf('en-us') > -1 ? 'en-us' : urls.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk') }}</span>
          </span>
        </p>
      </div>
      <p v-if="proInfo.rentalType == 2">
        <span>{{ lang.rent }}</span
        ><span class="value">{{ post.getPrice(proInfo.rentPrice, urls.indexOf('en-us') > -1 ? 'en-us' : urls.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk') }}</span>
      </p>
      <!-- 广告类型 -->
      <p>
        <span>{{ lang.topType }}</span
        ><span class="value">{{ proInfo.topType == 0 ? lang.Standard : proInfo.topType == 1 ? lang.superPan : lang.starPan }}{{ proInfo.isVerify && !(proInfo.propertySource ==1 && proInfo.topType == 0) ? lang.isVerify : '' }}</span>
      </p>
      <!-- 审核状态 -->
      <p>
        <span>{{ lang.active }}</span>
        <span class="value  van-ellipsis" v-if="proInfo.paymentStatus == 0">{{ lang.status.wait }}</span>
        <span class="value" v-else-if="proInfo.isAdminOffLine == true">{{ lang.status.Obtained }}</span>
        <span class="value" v-else-if="proInfo.paymentStatus == 1 && proInfo.approvalStatus == 0">{{ lang.status.passing }}</span>
        <span class="value" v-else-if="proInfo.paymentStatus == 1 && proInfo.approvalStatus == 1">{{ lang.status.passed }}</span>
        <span class="value" v-else-if="proInfo.paymentStatus == 1 && proInfo.approvalStatus == 2">{{ lang.status.nopass }}</span>
      </p>
      <!-- 楼盘状态 支付成功才显示状态 字典转换3-1-->
      <!-- paymentStatus: 1 -->
      <p v-if="proInfo.paymentStatus == 1 && proInfo.rentalType == 1">
        <span>{{ lang.pstatus }}</span
        ><span class="value">{{ SalePropertyStatus[propertyStatus == 3 ? 2 : propertyStatus].dictionaryNameWithCulture }}</span>
      </p>
      <p v-if="proInfo.paymentStatus == 1 && proInfo.rentalType == 2">
        <span>{{ lang.pstatus }}</span
        ><span class="value">{{ RentPropertyStatus[propertyStatus == 3 ? 2 : propertyStatus].dictionaryNameWithCulture }}</span>
      </p>
      <!-- 显示楼盘 -->
      <!-- <p><span>{{lang.show}}</span><span class="value">{{proInfo.isHide == false ? '顯示樓盤' : '隱藏樓盤'}}</span></p> -->
      <p>
        <span>{{ lang.showORhide }}</span
        ><span class="value">{{ showStatus == false ? lang.show : lang.hide }}</span>
      </p>
      <!-- 浏览人数 -->
      <p>
        <span>{{ lang.visitorsNum }}</span
        ><span class="value">{{ proInfo.browseNumber }}</span>
      </p>
      <!-- 到期日 -->
      <p v-if="proInfo.paymentStatus == 1">
        <span>{{ lang.exday }}</span
        ><span class=" value">{{ proInfo.expireTime | getTime }} {{ payStatus === 2 ? `(${lang.exdayed})` : '' }}</span>
      </p>
      <!-- 地区排名次序（2022-11-11，删除） -->
      <!-- <p>
        <span>{{ lang.ranking }}</span
        ><span v-if="proInfo.ranking" class="value">{{ proInfo.ranking }}</span
        ><span class="value" v-else> - </span>
      </p> -->
      <!-- 可免費重新排序次數 -->
      <p>
        <span>{{ lang.recommendNumber }}</span
        ><span class="value">{{ proInfo.topType == 0 ? '0' : recommendNumber }}</span>
      </p>
      <!-- 预设页面 >0展示-->
      <p v-if="proInfo.topType == 3 && proInfo.globalRank > 0">
        <span>{{ lang.defaultPage }}</span>
        <span class="value">
          <i v-if="url">{{ lang.Page }}{{ proInfo.globalRankPage }}</i>
          <i v-else>{{ proInfo.globalRankPage }}{{ lang.Page }}</i>
          <i v-if="url">,{{ lang.Position }}{{ proInfo.globalRank }}</i>
          <i v-else>,{{ lang.di }}{{ proInfo.globalRank }}{{ lang.Position }}</i>
        </span>
      </p>
      <!-- 18區頁面 -->
      <p v-if="proInfo.topType == 3 && proInfo.zoneRank > 0">
         <span>{{ lang.DistrictPage }}</span>
        <span class="value">
          <i v-if="url">{{ lang.Page }}{{ proInfo.zoneRankPage }}</i>
          <i v-else>{{ proInfo.zoneRankPage }}{{ lang.Page }}</i>
          <i v-if="url">,{{ lang.Position }}{{ proInfo.zoneRank }}</i>
          <i v-else>,{{ lang.di }}{{ proInfo.zoneRank }}{{ lang.Position }}</i>
        </span>
      </p>
    </div>

    <!-- 立即付款  精选盘暂不准付款||续期 -->
    <van-cell :title="lang.pay" @click="payStatus == 0 && yzStatus && pay()" :class="{ disableAlight: payStatus !== 0 || !yzStatus}" v-if="proInfo.topType != 1" />
    <!-- 楼盘修改 -->
    <van-cell :title="lang.editPro" @click="edit()" />
    <!-- 复制楼盘 -->
    <van-cell :title="lang.copy" @click="copy()" />
    <!-- 显示隐藏楼盘更改 -->
    <van-cell :title="lang.showORhide" @click="payStatus == 1 && !proInfo.isAdminOffLine && proShowClick()" :class="{ disableAlight: payStatus == 0 || payStatus == 2 || proInfo.isAdminOffLine == true }" />
    <van-popup v-model="proShow" class="popup" :overlay="false">
      <van-nav-bar :title="lang.showORhide" left-arrow @click-left="proShow = false" :right-text="lang.confirm" @click-right="proShow = false"></van-nav-bar>
      <van-radio-group v-model="showStatus">
        <van-cell :title="lang.show" clickable @click="changeShow(false)">
          <van-radio :name="false" checked-color="#ED1818" @click.stop="changeShow(false)" />
        </van-cell>
        <van-cell :title="lang.hide" clickable @click="changeShow(true)">
          <van-radio :name="true" checked-color="#ED1818" @click.stop="changeShow(true)" />
        </van-cell>
      </van-radio-group>
    </van-popup>
    <!-- 推顶（重新置顶） -->
    <van-cell
      :title="lang.push"
      @click="payStatus == 1 && !proInfo.isAdminOffLine && proInfo.topType && fresh()"
      :class="{ disableAlight: payStatus == 0 || payStatus == 2 || proInfo.isAdminOffLine || proInfo.topType === 0 }"
    />
    <!-- 楼盘状态更改 -->
    <van-cell :title="lang.editActive" @click="payStatus == 1 && !proInfo.isAdminOffLine && statusChageClick()" :class="{ disableAlight: payStatus == 0 || payStatus == 2 || proInfo.isAdminOffLine }"/>
    <van-popup v-model="statusShow" class="popup" :overlay="false">
      <van-nav-bar :title="lang.editActive" left-arrow @click-left="statusShow = false" :right-text="lang.confirm" @click-right="statusShow = false"></van-nav-bar>
      <van-radio-group v-model="propertyStatus" v-if="proInfo.rentalType == 1">
        <van-cell :title="item.dictionaryNameWithCulture" clickable @click="changeState(item)" v-for="item in SalePropertyStatus" :key="item.dictionaryValue">
          <van-radio :name="item.dictionaryValue" checked-color="#ED1818" @click.stop="changeState(item)" />
        </van-cell>
      </van-radio-group>
      <van-radio-group v-model="propertyStatus" v-if="proInfo.rentalType == 2">
        <van-cell :title="item.dictionaryNameWithCulture" clickable @click="changeState(item)" v-for="item in RentPropertyStatus" :key="item.dictionaryValue">
          <van-radio :name="item.dictionaryValue" checked-color="#ED1818" @click.stop="changeState(item)" />
        </van-cell>
      </van-radio-group>
    </van-popup>
    <!-- 续期 -->
    <van-cell :title="lang.addLight" @click="!xjStatus && yzStatus && payStatus !== 0 && addLight()" :class="{ disableAlight: (payStatus == 0 || xjStatus || !yzStatus) }" v-if="proInfo.topType != 1" />
    <!-- 删除 -->
    <van-cell :title="lang.delete" @click="del()" v-if="proInfo.paymentStatus == 0 || payStatus == 2"  />
    <van-dialog v-model="submitLight" :showConfirmButton=false :show-cancel-button=false class="cancel-edit" >
          <div class="divcon-renew">
            <p class="con-renew">{{lang.renewDate}}</p>
            <p class="con-renew">{{expireTimeFormat}}</p>
          </div>
          <div class="divcon-renew">
            <p class="con-renew">{{lang.renewRemain}}</p>
            <p class="con-renew" v-if="expireDay">{{expireDays}}{{ url && expireDays == 1 ?lang.renewDay:lang.renewDays }}</p>
            <p class="con-renew" v-else>{{expireHour}}{{  url && expireHour==1? lang.renewHour:lang.renewHours }}</p>
            
          </div>
          <div class="divcon-renew">
            <p class="con-renew">{{lang.renewAfter}}</p>
            <p class="con-renew">{{ refreshExpireTimeFormat}}</p>
          </div>
          <div class="divcon-renew">
            <p class="con-renew">{{lang.renewGo}}</p>
          </div>    
          <van-button class='editBut editbutsize' @click="submitLight = false">{{lang.cancelBtn}} </van-button>
          <van-button type="danger" class="editbutsize" @click="goAddLight">{{ lang.confirmBtn }} </van-button>
    </van-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { Toast, Dialog } from 'vant';
import lang from './../../common/language/editProperty';
import post from './../../common/js/post';
export default {
  data() {
    return {
      lang,
      post,
      submitLight:false,
      shopShow: false,
      url: document.URL.indexOf('en-us') > -1,
      urls: document.URL,
      result: false,
      propertyId: 0,
      orderID: 0,
      proInfo: {},
      userInfo: {},
      statusShow: false,
      proShow: false,
      propertyStatus: 0, // 楼盘状态
      showStatus: false, // 显示状态
      xjStatus:false,
      yzStatus:true,
      nowTime: new Date().getTime() / 1000,
      propertyID: 0,
      recommendNumber: 0,
      SalePropertyStatus: [],
      RentPropertyStatus: [],
      expireTime:'',
      expireTimeFormat:'',
      expireTimeDay:'',
      refreshExpireTime:'',
      refreshExpireTimeFormat:'',
      expireDay:'',
      expireHour:'',
      continRenew:true,
    };
  },
  created() {
    this.propertyId = this.$route.params.id;
    this.getOneProperty();
    this.getDictionary();

  },
  mounted() {
    // this.$store.commit('clearAll');
    // sessionStorage.removeItem('once');
  },
  filters: {
    salePrice(val) {
      if (document.URL.indexOf('en-us') > -1) {
        val = val / 1000000;
      } else {
        val = val / 10000;
      }
      let contain = String(val).indexOf('.');
      if (contain > -1) {
        contain = String(val).substring(contain + 1, String(val).length);
        if (contain.length == 1) {
          return val.toFixed(1);
        } else {
          return val.toFixed(2);
        }
      }
      return parseInt(val);
    },
    avgPrice(val) {
      return Math.round(val);
    }
  },
  computed: {
    ...mapState(['propertyUserInfo', 'propertyInfo']),
    payStatus() {
      let pay = this.proInfo.paymentStatus;
      if (pay) {
        // 支付成功 并且 未被管理员下架
        if (parseInt(this.nowTime) <= this.proInfo.expireTime) {
          return 1; // 未过期
        } else {
          return 2; // 已过期
        }
        // expireTime	integer($int64) 放盘到期时间 >= 当前时间  说明已经过期
      } else {
        return 0; // 未支付
      }
    },
    expireDays(){
     return this.expireHour?this.expireDay+1:this.expireDay
    }
  },
  methods: {
    goAddLight(){
      this.submitLight = false
      this.continRenew = false 
      this.addLight()
    },
    // 删除楼盘
    del(){
      this.$dialog
          .confirm({
            title: this.lang.selectedprop,
            message: this.lang.selectedproped,
            cancelButtonText: lang.cancel,
            confirmButtonText: lang.confirm
          })
          .then(() => {
            this.axios.post(this.pub.getApi().DeletePropertyById, { propertyId: this.propertyId }).then(result => {
              if (result.data.code === 0 && result.data.result) {
                this.$router.go(-1)
                this.$toast.success(lang.delsus)
              } else {
                this.$toast.fail(lang.noChance);
              }
            });
          });
    },
    // ...mapMutations(['stepChange', 'clearAll']),
    statusChageClick() {
      this.statusShow = true;

      if (this.payStatus === 1) {
        this.statusShow = true;
      }
    },
    proShowClick() {
      if (this.payStatus === 1) {
        this.proShow = true;
      }
    },
    // 获取楼盘状态配置
    getDictionary() {
      this.pub.getDictionary().then(res => {
        this.RentPropertyStatus = [...res.RentPropertyStatus.children];
        this.SalePropertyStatus = [...res.SalePropertyStatus.children];
        this.shopShow = true;
      });
    },
    // 获取单个房源信息
    getOneProperty() {
      this.axios.post(this.pub.getApi().SearchUserPublishProperty, { propertyIds: [this.propertyId], pageIndex: 1, pageCount: 10 }).then(res => {
        if (res.data.result.count == 0) {
          if (document.URL.indexOf('en-us') > -1) {
            location.href = `/en-us/404/`;
          } else if (document.URL.indexOf('zh-cn') > -1) {
            location.href = `/zh-cn/404/`;
          } else {
            location.href = `/404/`;
          }
          return;
        }
        if (res.data.code === 0 && res.data.result) {
          this.result = true;
          this.proInfo = res.data.result.data[0];
          console.log("this.proInfo",this.proInfo)
          this.propertyID = this.proInfo.propertyID;
          this.propertyStatus = String(this.proInfo.propertyStatus); // 楼盘状态赋值
          this.showStatus = this.proInfo.isHide;
          this.xjStatus=this.proInfo.isAdminOffLine
          this.yzStatus = this.proInfo.allowRenewal
          this.recommendNumber = this.proInfo.recommendNumber; //剩余推定次数
        }
      });
    },
    pay() {
      this.axios.get(this.pub.getApi().VerifyPropertyCanRenewal, {
        params: {
          propertyId: this.propertyId
        }
      }).then((res) => {
        if (res.status == 200 && res.data.code == 0) {
          if (res.data.result) {
            // 立即付款 type = 1
            this.$router.push({ name: 'post', query: { id: this.propertyId, type: 1, fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
          } else {
            Dialog.confirm({
              title: '',
              message: lang.parNowText,
              confirmButtonText: lang.confirmBtn,
              cancelButtonText: lang.cancelBtn
            })
            .then(() => {
              this.$router.push({ name: 'post', query: { id: this.propertyId, type: 'edit', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
              // on confirm
            })
            .catch(() => {
            });
          }
        }
      })

    },
    addLight() {
      // 楼盘还未到期 弹出确认框
      if(this.proInfo.expireTime > Date.parse(new Date())/1000 && this.continRenew){
        this.axios.get(this.pub.getApi().GetPropertyRenewalInfo, {
          params: {
            propertyId: this.propertyId
          }
        }).then((res)=>{
          this.expireTime = res.data.result.expireTime
          this.expireTimeFormat = res.data.result.expireTimeFormat
          this.refreshExpireTime = res.data.result.refreshExpireTime
          this.refreshExpireTimeFormat = res.data.result.refreshExpireTimeFormat
          this.expireDay = res.data.result.expireDay
          this.expireHour = res.data.result.expireHour
        })
        this.submitLight = true //弹出弹框
      }
      if(!this.continRenew || this.proInfo.expireTime < Date.parse(new Date())/1000){
        this.axios.get(this.pub.getApi().VerifyPropertyCanRenewal, {
          params: {
            propertyId: this.propertyId
          }
        }).then((res) => {
          if (res.status == 200 && res.data.code == 0) {
            if (res.data.result) {
              // 在有效期内只允许续期一次
              if (this.proInfo.renewalNumber == 0 || this.proInfo.expireTime < Date.parse(new Date()) / 1000) {
                this.$router.push({ name: 'post', query: { id: this.propertyId, type: 2, fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
              } else {
                Toast.setDefaultOptions({ className: 'center' });
                this.$toast(this.lang.maxRenewal);
              }
            } else {
              Dialog.confirm({
                title: '',
                message: lang.noRenewalText,
                confirmButtonText: lang.confirmBtn,
                cancelButtonText: lang.cancelBtn
              })
              .then(() => {
                this.$router.push({ name: 'post', query: { id: this.propertyId, type: 'edit', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
                // on confirm
              })
              .catch(() => {
                this.continRenew = true
              });
            }
          } 
          return
        })
      }
    },
    edit() {
      // this.stepChange(1);
      this.$router.push({ name: 'post', query: { id: this.propertyId, type: 'edit', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
    },
    copy() {
      // this.stepChange(1);
      this.$router.push({ name: 'post', query: { id: this.propertyId, type: 'copy', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
    },
    // 楼盘状态更改
    changeState(item) {
      this.axios
        .get(this.pub.getApi().UpdatePropertyStatus, { params: { propertyId: this.propertyId, propertyStatus: item.dictionaryValue } })
        .then(res => {
          if (res.data.code === 0 && res.data.result) {
            this.propertyStatus = item.dictionaryValue;
          } else {
            this.$toast.fail(lang.noChance);
          }
        })
        .catch(error => {
          this.$toast.fail(lang.noChance);
        });
    },
    fresh() {
      if (this.recommendNumber) {
        this.$dialog
          .confirm({
            title: this.lang.rank,
            message: this.lang.ranked,
            cancelButtonText: lang.cancel,
            confirmButtonText: lang.confirm
          })
          .then(() => {
            this.axios.get(this.pub.getApi().RefreshPropertyAndRecommendById, { params: { propertyId: this.propertyId } }).then(result => {
              if (result.data.code === 0 && result.data.result) {
                if (this.proInfo.topType === 3) {
                  this.$toast.success(lang.starPush + '\n' + lang.starPushTip);
                } else {
                  this.$toast.success(lang.pushSuccess);
                }
                this.recommendNumber = this.recommendNumber - 1;
              } else {
                this.$toast.fail(lang.noChance);
              }
            });
          });
      } else {
        this.$dialog.alert({
          title: this.lang.norank,
          cancelButtonText: lang.cancel,
          confirmButtonText: lang.confirm
        });
      }
    },
    changeShow(data) {
      this.axios
        .get(this.pub.getApi().UpdatePropertyShowStatus, { params: { propertyId: this.propertyId, isHide: data } })
        .then(result => {
          if (result.data.code === 0 && result.data.result) {
            this.showStatus = data;
          } else {
            this.$toast.fail(lang.noChance);
          }
        })
        .catch(error => {
          this.$toast.fail(lang.noChance);
        });
    },
    prev() {
      this.$router.push('/my-properties/');
    }
  },
  components: {
    [Toast.name]: Toast
  },
  destroyed() {
    this.$dialog.close();
  },
  metaInfo() {
    return {
      title: this.lang.infoEdit
    };
  }
};
</script>
<style>
.van-toast--default {
  width: 200px !important;
  padding: 15px;
  min-height: 90px;
  text-align: center !important;
}
</style>
<style scoped lang="scss">
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 500;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
.disableAlight{
  color: #ccc;
  cursor: not-allowed;
  // pointer-events: none; 导致禁用时点击padding部分 触发其余高亮按钮事件
}

.editDetail {
  width: 100%;
  height: 100%;
  background-color: #f4f6f6;
  text-align: left;
}
.cancel-edit{
  padding:24px;
  width:75%;
  border-radius: 8px;
    .divcon-renew{
      margin-bottom:16px;
      line-height:22px;
    }
    .con-renew{
      font-size: 16px;
      margin-bottom:5px;
      color:#333333;
      font-weight: 700;
    }
    .editBut{
      background-color: #DDDDDD;
      margin-right:25px;
    }
    .editbutsize{
      width:45%;
      border-radius:4px;
    }
}
.info {
  margin: 16px 0 16px;
  padding: 8px 8px;
  background-color: #fff;
  p {
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    margin-bottom: 15px;
    span {
      width: 45%;
      display: inline-block;
    }
    span.value {
      color: black;
      display: inline-block;
      width: 55%;
      // height: 22px;
    }
    .values{
      color: black;
      display: inline-block;
      width: 20%;
    }
    .valuePaid{
      color: black;
      display: inline;
    }
    .topPaid{
      padding-right: 15px;
      padding-bottom: 10px;
    }
    .valuePaids{
      display: inline-block;
      min-width:100%
    }
    .xjvalues{
      width:75px;
      height:25px;
      background-color: #f2f2f2;
      text-align: center;
      line-height: 25px;
      color:black;
    }
  }
}
.saleSpan{
  vertical-align: top !important;
}
.popup {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.center {
  text-align: center !important;
}
</style>
